'use client';

import { BottomDrawer, Button } from '@common/components';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { BANNER_CONTENTS_TYPE } from '@/api';
import { UnauthQueryOptions } from '@/api/v2';
import { LazyImage } from '@/components/client';
import { SELECTOR, STORAGE_KEY } from '@/constants';
import { useCheckWelloApp } from '@/hooks/useCheckWelloApp';
import { useAuthStore } from '@/stores/AuthStore';

import styles from './HometownNewsDetailBottomDrawer.module.scss';

export const HometownNewsDetailBottomDrawer = () => {
  const [isShow, setIsShow] = useState(false);
  const { isWelloApp } = useCheckWelloApp();
  const isLogin = useAuthStore((state) => state.isLogin);

  const { data, isLoading } = useQuery({
    ...UnauthQueryOptions['get:/wello/v2/allows/banner']({
      query: {
        contents_type_cd: BANNER_CONTENTS_TYPE.HOMETOWN_BOTTOM_SHEET,
      },
    }),
  });

  const banner = (data?.context?.contents ?? [])[0];

  const applyFileUrl = isWelloApp ? banner?.app_file_url : banner?.file_url;
  const applyLinkUrl = isWelloApp ? banner?.app_link_url : banner?.link_url;

  useEffect(() => {
    if (!window || !sessionStorage) return;

    const bottomDrawerShowPathname = sessionStorage.getItem(
      STORAGE_KEY.HOMETOWN_NEWS_DETAIL_BOTTOM_DRAWER_PATH,
    );

    setTimeout(() => {
      setIsShow(bottomDrawerShowPathname === window.location.pathname);
      sessionStorage.removeItem(
        STORAGE_KEY.HOMETOWN_NEWS_DETAIL_BOTTOM_DRAWER_PATH,
      );
    }, 2000);
  }, []);

  const handleClick = () => {
    if (!applyLinkUrl) return;
    window.location.href = applyLinkUrl;
  };
  const handleClose = () => {
    setIsShow(false);
  };

  const isNoRender =
    !!isLogin || (!isLoading && !banner) || !(applyFileUrl && applyLinkUrl);

  if (isNoRender) return null;

  return (
    <BottomDrawer
      opened={isShow}
      renderTo={() => document.getElementById(SELECTOR.MAIN_WRAPPER)}
      onClose={handleClose}
    >
      <BottomDrawer.HandleWrapper>
        <BottomDrawer.Handle />
      </BottomDrawer.HandleWrapper>
      <BottomDrawer.Contents className="mx-0 flex flex-col justify-between">
        <section className="flex flex-col items-center gap-28 px-[47.5px] py-5 pb-16">
          <section className="flex flex-col items-center gap-4 text-center">
            <p className="whitespace-pre-wrap font-700 text-Gray-900 typo-body1">
              {banner.title}
            </p>
            <p className="whitespace-pre-wrap font-400 text-Gray-700 typo-body4">
              {banner.subtitle}
            </p>
          </section>
          <LazyImage className={styles.thumbnail} src={applyFileUrl} />
        </section>
        <section className="flex items-center justify-center px-20 py-16">
          <Button
            className="w-full whitespace-pre-wrap px-0 py-16"
            theme="primary-fill"
            onClick={handleClick}
          >
            {banner.button_text}
          </Button>
        </section>
      </BottomDrawer.Contents>
    </BottomDrawer>
  );
};
